import React, { useState } from 'react'
import Input from '../../components/TextInput'
import Select from '../../components/SelectInput'
import Btn from '../../components/Buttons/SaveButton'
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux'
import { toggleLoading } from '../../redux/actions'

import { req, plateTypes } from '../../util'
import LocalIcon from '../../components/Icons/LocalIcon'
import CloudIcon from '../../components/Icons/CloudIcon'

const newCar = {
    client: "",
    phone: "",
    brand: "",
    model: "",
    year: "",
    color: "",
    plateNo: "",
    plateType: "",
    bodyCheck: true,
    engineCheck: true,
    vinNo: ""
}

export const Car = () => {
    const dispatch = useDispatch()
    const [car, setCar] = useState(newCar)
    const [similarCars, setSimilarCars] = useState([])
    const [cloudErr, setCloudErr] = useState(false)
    const [localErr, setLocalErr] = useState(false)
    const [similarSearch, setSimilarSearch] = useState("")


    const submit = async () => {
        let notValid = Object.keys(car).map(k => car[k]).some(v => v === null || v === undefined || v === "")
        if (notValid) return alert("يرجى التاكد من المعلومات المدخلة")
        if (car?.vinNo?.length != 17) return alert("الرقم الشاصي غير صالح")
        let exam = car.bodyCheck || car.engineCheck
        if (!exam) return alert("يرجى اختيار نوع القحص")
        let { success, msg } = await req("POST", "car", { ...car, plateType: car.plateType.value })
        if (!success) {
            return alert(msg)
        }
        setCar(newCar)
    }

    const getSimilar = async (plateNo) => {
        try {

            if (!plateNo) return
            dispatch(toggleLoading())
            let { success: successLocal, data: dataLocal } = await req("GET", `car/similar?plateNo=${plateNo}`)

            if (!successLocal) setLocalErr(true)
            if (successLocal) setLocalErr(false)

            let localCars = dataLocal.map(d => ({ ...d, link: d.source === "local" ? `/writeReport?id=${d.id}` : `http://bodycar.wavesys.io:9002/writeReport?id=${d.id}` }))

            setSimilarCars([...localCars])
            dispatch(toggleLoading())
        } catch (err) {
            dispatch(toggleLoading())
            console.log(err)
            setLocalErr(true)
        }
    }


    const getSimilarByVin = async (vinNo) => {
        try {
            if (!vinNo) return
            dispatch(toggleLoading())
            let { success: successLocal, data: dataLocal } = await req("GET", `car/similar/vin?vinNo=${vinNo}`)
            let { success: successCloud, data: dataCloud } = await req("GET", `car/similar/vin/autel?vinNo=${vinNo}`)

            if (!successLocal) setLocalErr(true)
            if (!successCloud) setCloudErr(true)

            if (successLocal) setLocalErr(false)
            if (successCloud) setCloudErr(false)

            let localCars = dataLocal.map(d => ({ ...d, link: `/writeReport?id=${d.id}`, source: 'local' }))
            let cloudCars = dataCloud.map(d => ({ ...d, source: 'autel' }))

            setSimilarCars([...localCars, ...cloudCars])
            dispatch(toggleLoading())

        } catch (err) {
            dispatch(toggleLoading())
            console.log(err)
            setLocalErr(true)
            setCloudErr(true)
        }
    }

    return (
        <div className="container mx-auto p-4">
            <div className="text-center text-lg font-semibold text-gray-700">معلومات العجلة</div>
            <div className="md:flex md:flex-wrap md:justify-center md:items-center">
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <span className="font-semibold px-1 text-gray-800">اسم الزبون</span>
                    <Input
                        value={car.client}
                        onChange={evt => setCar({ ...car, client: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <span className="font-semibold px-1 text-gray-800">رقم الهاتف</span>
                    <Input
                        value={car.phone}
                        onChange={evt => setCar({ ...car, phone: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <span className="font-semibold px-1 text-gray-800">الماركة</span>
                    <Input
                        value={car.brand}
                        onChange={evt => setCar({ ...car, brand: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <span className="font-semibold px-1 text-gray-800">النوع</span>
                    <Input
                        value={car.model}
                        onChange={evt => setCar({ ...car, model: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <span className="font-semibold px-1 text-gray-800">سنة الصنع</span>
                    <Input
                        value={car.year}
                        onChange={evt => setCar({ ...car, year: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <span className="font-semibold px-1 text-gray-800">اللون</span>
                    <Input
                        value={car.color}
                        onChange={evt => setCar({ ...car, color: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <div className='flex'>
                        <span className="font-semibold px-1 text-gray-800">رقم اللوحة</span>
                        <span className="font-semibold px-1 text-blue-800 cursor-pointer" onClick={() => getSimilar(car.plateNo)}>بحث</span>
                        <CloudIcon className="w-4 h-4 mx-2" fill={localErr ? "red" : "green"} />
                    </div>
                    <Input
                        value={car.plateNo}
                        onChange={evt => setCar({ ...car, plateNo: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <div className='flex'>
                        <span className="font-semibold px-1 text-gray-800">رقم الشاصي</span>
                        <span className="font-semibold px-1 text-blue-800 cursor-pointer" onClick={() => getSimilarByVin(car.vinNo)}>بحث</span>
                        <LocalIcon className="w-4 h-4 mx-2" fill={localErr ? "red" : "green"} />
                        <CloudIcon className="w-4 h-4 mx-2" fill={cloudErr ? "red" : "green"} />
                    </div>
                    <Input
                        value={car.vinNo}
                        onChange={evt => setCar({ ...car, vinNo: evt.target.value })}
                    />
                </div>
                <div className="flex flex-col px-1 mt-2 md:w-1/3">
                    <span className="font-semibold px-1 text-gray-800">نوع اللوحة</span>
                    <Select
                        options={plateTypes}
                        value={car.plateType}
                        onChange={val => setCar({ ...car, plateType: val })}
                        placeholder=""
                    />
                </div>
                <div className="w-full lg:w-1/4 text-center my-4">
                    <Btn onClick={submit} />
                </div>
            </div>
            {/* limit the hight to 50% screen hight */}
            {/* each car should be shown in it's own area */}
            {/* add search input refine search by model and brand */}
            {similarCars.length > 0 &&
                <div className='flex flex-wrap items-center justify-center'>
                    <div className="flex flex-col p-1 mt-2">
                        <span className="font-semibold px-1 text-gray-800">بحث</span>
                        <Input
                            value={similarSearch}
                            onChange={evt => setSimilarSearch(evt.target.value)}
                        />
                    </div>
                    <div className='flex flex-wrap w-full items-center justify-center'>
                        {similarCars.filter(s => s.plateNo.includes(similarSearch) || s.brand.includes(similarSearch) || s.model.includes(similarSearch)).map(s => {
                            if (s.source === "autel") return (
                                <div className={`border-blue-700 border-2 m-2 p-2 rounded-md bg-gray-300 md:w-1/3 lg:w-1/4 select-none cursor-pointer text-lg font-semibold text-blue-600 shadow-md`} key={`autel-${s.id}`}>
                                    <div>تاريخ الفحص {dayjs(s.created_at).format("YYYY-MM-DD")}</div>
                                    <div>رقم الفرع {s.branch}</div>
                                </div>
                            )

                            return (
                                <a href={s.link} target="_blank" className={`${s.source === "cloud" ? 'border-green-500' : 'border-blue-700'} border-2 m-2 p-2 rounded-md bg-gray-300 md:w-1/3 lg:w-1/4 select-none text-lg font-semibold text-blue-600 shadow-md items-center justify-center`} key={`cars-${s.id}`}>
                                    <div>الماركة : {s.brand}</div>
                                    <div>النوع : {s.model}</div>
                                    <div>سنة الصنع : {s.year}</div>
                                    <div> رقم اللوحة : {s.plateNo} - {s.plateType}</div>
                                    <div>تاريخ الفحص : {dayjs(s.created_at).format("YYYY-MM-DD")}</div>
                                    <div>رقم الفرع : {s.branch}</div>
                                </a>
                            )
                        })}
                    </div>
                </div>
            }
        </div>
    )
}